import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
} from "@mui/material";
import { Add, ViewList, GridView, Home } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
// import { getProjectCounts } from "../../Services/api/projectService";
import { useProjectApiClient } from "../../Services/api/projectService"

import { useAppContext } from '../../../hooks/context/AppContext';
import HomeHelp from "../../pages/HomeHelp";
import { projectVersion } from "config/navConfig";


interface Permissions {
  CanRead: boolean;
  CanView: boolean;
  CanCopy: boolean;
  CanDelete: boolean;
  CanEdit: boolean;
  CanCreate: boolean;
}

interface User {
  Email: string;
  FullName: string;
  Role: string;
  module: string;
  permissions: Permissions;
}

//  Props for ProjectFilters Component
interface ProjectFiltersProps {
  onFilterChange: (filter: string) => void;
  selectedFilter: string;
  viewType: string;
  onViewChange: (view: string) => void;
}

const ProjectFilters: React.FC<ProjectFiltersProps> = ({
  onFilterChange,
  selectedFilter,
  viewType,
  onViewChange,
}) => {
  const { getProjectCounts } =  useProjectApiClient();
  const { userData } = useAppContext();
  const [counts, setCounts] = useState({ all: 0, saved: 0, draft: 0 });
  const [user, setUser] = useState<User | null>(null); 


  
  const navigate = useNavigate();
  const { appData, updateAppData } = useAppContext();

  let handleHomeClick = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/`);
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true, url: `/` });
    }
  }
  
  // Fetch project counts when component mounts
  useEffect(() => {
    const fetchCounts = async () => {
      const data = await getProjectCounts();
      if (data) {
        setCounts({
          all: data.totalProject,
          saved: data.projectActive,
          draft: data.projectInactive,
        });
      }
    };
    fetchCounts();
  }, []);

  useEffect(() => {
    if(userData){
      // @ts-ignore
      setUser(userData)
    }
  
  }, [userData]);


  return (
    <AppBar position="static" sx={{ backgroundColor: "transparent", boxShadow: "none", padding: "10px" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px", borderRadius: "8px" }}>
        
        {/*  Left - Filters */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>

        <IconButton onClick={() => handleHomeClick()}  sx={{ color: "#003399" }}>
          <Home fontSize="medium" />
        </IconButton>

          <Typography sx={{ fontWeight: "bold", color: "black", fontSize:"14px"}}>My Projects</Typography>

          {/* Individual Styled Buttons */}
          <Button
            onClick={() => onFilterChange("all")}
              title="Total No.of Projects"
            sx={{
              backgroundColor: selectedFilter === "all" ? "#002299" : "white",
              color: selectedFilter === "all" ? "white" : "#002299",
              fontWeight: "bold",
              fontSize:"12px",
              borderRadius: "20px",
              padding: "2px 16px",
              textTransform: "none",
              border: "1px solid #002299",
              "&:hover": { backgroundColor: "#2A3FBF", color: "white" },
            }}
          >
            All ({counts.all})
          </Button>

          <Button
            onClick={() => onFilterChange("saved")}
            title="No.of Saved Projects"
            sx={{
              backgroundColor: selectedFilter === "saved" ? "#16e17f" : "white",
              color: selectedFilter === "saved" ? "white" : "#16e17f",

              // backgroundColor: "white",
              // color: selectedFilter === "saved" ? "#00B386" : "#00B386",
              fontWeight: "bold",
              fontSize:"12px",
              borderRadius: "20px",
              padding: "2px 16px",
              textTransform: "none",
              // border: "2px solid #00B386",
              border: "1px solid #16e17f",
              "&:hover": { backgroundColor: "#16e17f", color: "white" },
            }}
          >
            Saved ({counts.saved})
          </Button>

          <Button
            onClick={() => onFilterChange("draft")}
             title="No.of Draft Projects"
            sx={{
              backgroundColor: selectedFilter === "draft" ? "#f9a630" : "white",
              color: selectedFilter === "draft" ? "white" : "#f9a630",
              // backgroundColor: "white",
              // color: "#666",
              fontWeight: "bold",
              fontSize:"12px",
              borderRadius: "20px",
              padding: "2px 16px",
              textTransform: "none",
              border: "1px solid #f9a630",
              "&:hover": { backgroundColor: "#f9a630", color: "white" },
            }}
          >
            Draft ({counts.draft})
          </Button>
        </Box>

        {/*  Right - View Toggle & Create Project */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}> 
          {/* Create Project Button */}
          <Button
            disabled = {user?.permissions?.CanCreate == true ? false : true}
            onClick={() => { navigate(`${projectVersion}/create-project`); }}
            variant="contained"
            startIcon={<Add />}
            sx={{
              backgroundColor: "#003399",
              fontWeight: "bold",
              fontSize: "14px",
              borderRadius: "20px",
              padding: "8px 16px",
              marginRight:"10px",
              "&:hover": { backgroundColor: "#002266" },
            }}
          >
            Create New Project
          </Button>

          {/* View Toggle Buttons */}
          <IconButton onClick={() => { onViewChange("grid"); navigate(`${projectVersion}/projects-grid`); }} sx={{ color: viewType === "grid" ? "#003399" : "#a5a5a5" }}>
            <GridView fontSize="medium" />
          </IconButton>

          <IconButton onClick={() => { onViewChange("list"); navigate(`${projectVersion}/project`); }} sx={{ color: viewType === "list" ? "#003399" : "#a5a5a5" }}>
            <ViewList fontSize="medium" />
          </IconButton>
          {/* Custom Help Icon */}
          <HomeHelp />
        </Box>
       

      </Toolbar>
    </AppBar>
  );
};

export default ProjectFilters;
